import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ICardPunchRecord, pagePunchRecords,deletePunchRecord} from '../../service/api/card';
import moment from 'moment';
import { FormInstance } from 'antd/lib/form/Form';
import umbrella from 'umbrella-storage';
const { confirm } = Modal;
const { TabPane } = Tabs;

interface IPunchRecordListProps {
  studentId?: any
}

const PunchRecordList: React.FC<IPunchRecordListProps> = ({
  studentId,
}) => {
  const [cards, setPunchRecords] = useState<ICardPunchRecord[]>();
  const [cardDetail, setPunchRecordDetail] = useState<ICardPunchRecord>();
  const [cardVisible, setPunchRecordVisible] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const formRef = React.createRef<FormInstance>();

  const columns = [
    {
      title: '学员名称',
      dataIndex: 'studentName',
      key: 'studentName',
    },
    {
      title: '课程名称',
      dataIndex: 'courseName',
      key: 'courseName',
    },
    {
      title: '班级名称',
      dataIndex: 'teachClassName',
      key: 'teachClassName',
    },
    {
      title: '消耗课时数',
      dataIndex: 'costValue',
      key: 'costValue',
    },
    {
      title: '课包名称',
      dataIndex: 'cardName',
      key: 'cardName',
    },
    {
      title: '门店名称',
      dataIndex: 'storeName',
      key: 'storeName',
    },
    {
      title: '打卡时间',
      dataIndex: 'punchTime',
      key: 'punchTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD HH:mm') : <>&mdash;</>
      },
    },
    {
      title: '操作时间',
      dataIndex: 'creationTime',
      key: 'creationTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD HH:mm') : <>&mdash;</>
      },
    },
    {
      title: '操作',
      // fixed: 'right' as 'right',
      width: 60,
      key: 'action',
      render: (text: any, record: any) => {
        return <Space size="middle">
          {umbrella.getLocalStorage('username')=='陈士丹'?
          <a onClick={e => { onDelete(e, record) }}>删除</a>:<>无</>}
        </Space>
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (cardDetail) {
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(cardDetail);
      }, 100);
    }
  }, [cardDetail]);

  const loadData = () => {
    pagePunchRecords(pageNum, pageSize, studentId ? studentId : '').then((info: any) => {
      setPunchRecords(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
  }

  const onDelete = (e: any, item: ICardPunchRecord) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要删除该打卡记录吗？删除后无法恢复',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deletePunchRecord(item.id).then((info: any) => {
          if (info) {
            console.log("info:" + JSON.stringify(info));
            message.success("删除成功");
            loadData();
          }
        });
      },
      onCancel() {
      },
    });
  }

  const onClose = () => {
    setPunchRecordDetail(undefined);
    setPunchRecordVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    console.log("pageNum:" + pageNum);
    console.log("pageSize:" + pageSize);
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  return (
    <Card bordered={false}>
      <Table dataSource={cards} columns={columns} pagination={false} />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
        <Pagination
          defaultCurrent={pageNum}
          total={pageTotal}
          pageSize={pageSize}
          hideOnSinglePage={false}
          className="pagination"
          onChange={onPageChange}
          showSizeChanger
          showTotal={total => `共计 ${total} 条`}
        />
      </div>
    </Card>
  );
};

export default PunchRecordList;
